import { RiInformationFill } from "react-icons/ri";
import { genInvoiceUrl } from "../api/endpoints";
import { BsEyeFill } from "react-icons/bs";

const TransactionItem = ({ transaction, updateSelectedTrans, currency }) => {
  const handleClick = (e) => {
    let target = e.target;
    Array.from(target.parentNode.children).forEach((item) => {
      item.classList.remove("clickedTran");
    });
    target.classList.add("clickedTran");
    updateSelectedTrans(transaction);
  };

  const printReceipt = async () => {
    try {
      window.open(genInvoiceUrl + transaction._id, "_blank");
    } catch (error) {
      console.log(error);
    }
  };
  let imageUrl = `${transaction?.products[0].productImage.split("/upload/")[0]}/upload/f_auto,q_auto,w_70/${
    transaction?.products[0].productImage.split("/upload/")[1]
  }`;
  const getInitial = (name) => name.charAt(0).toUpperCase();
  return (
    <>
      <div className='eachTransUp764' onClick={(e) => handleClick(e)}>
        <div className='eachTransUp764Img'>
          {/*  <img className='imgTransItem77' loading='lazy' src={imageUrl} /> */}
          <div style={{ height: "50px", width: "51px" }} className='product-avatar'>
            <div className='product-initial-wrapper'>
              <span className='product-initial'>{getInitial(transaction.products[0]?.name)}</span>
            </div>
          </div>
          <p> {transaction.products[0]?.name}</p>
          <span> {transaction?.products.length > 1 ? ` + ${transaction?.products.length - 1} more` : ""} </span>
        </div>
        <div>
          <div className='transactionListStatus'>
            {transaction?.transactionDetails.deliveryStatus === "supplied" ? (
              <>
                <div className={`Tstatus  `}>
                  <span style={{ height: "6px", width: "6px", backgroundColor: "rgba(2, 122, 72, 1)", borderRadius: "40px" }}></span>
                  <span> Supplied</span>
                </div>
              </>
            ) : transaction?.transactionDetails.deliveryStatus === "returned" ? (
              <div style={{ backgroundColor: "rgb(241, 241, 241)" }} className={`Tstatus  `}>
                <span style={{ height: "6px", width: "6px", backgroundColor: "rgb(96, 96, 96)", borderRadius: "40px" }}></span>
                <span style={{ color: "rgb(78, 78, 78)" }}> returned</span>
              </div>
            ) : (
              <div style={{ backgroundColor: "rgba(254, 246, 245, 1)" }} className={`Tstatus TstatusLoanNotCleared `}>
                <span style={{ height: "6px", width: "6px", backgroundColor: "rgba(244, 67, 54, 1)", borderRadius: "40px" }}></span>
                <span style={{ color: "rgba(244, 67, 54, 1)" }}> Not supplied</span>
              </div>
            )}
          </div>
        </div>
        <div>
          {currency + " "}
          {transaction?.products[0]?.soldUnitPrice.toLocaleString()}
        </div>
        <div>
          {currency + " "}
          {transaction?.transactionDetails.totalAmount.toLocaleString()}{" "}
        </div>
        <div>
          <BsEyeFill color='rgb(84, 136, 247)' size={16} />
        </div>

        {transaction.transactionDetails.modified && (
          <span className='modiTag50122'>
            <RiInformationFill size={14} />
          </span>
        )}
      </div>
      {/* mobile display */}
      <div onClick={() => updateSelectedTrans(transaction)} className='transaction-card'>
        <div className='transaction-card-content'>
          {/* Product Info */}
          <div className='transaction-card-product-info'>
            <div style={{ height: "50px", width: "51px" }} className='product-avatar'>
              <div className='product-initial-wrapper'>
                <span className='product-initial'>{getInitial(transaction.products[0]?.name)}</span>
              </div>
            </div>
            <div className='transaction-card-details'>
              <h3 className='transaction-card-product-name'>
                {transaction.products[0]?.name}
                {transaction?.products.length > 1 ? ` + ${transaction?.products.length - 1} more` : ""}
              </h3>
              <div className='transaction-card-status-row'>
                <div className='transactionListStatus'>
                  {transaction?.transactionDetails.deliveryStatus === "supplied" ? (
                    <>
                      <div className={`Tstatus  `}>
                        <span style={{ height: "6px", width: "6px", backgroundColor: "rgba(2, 122, 72, 1)", borderRadius: "40px" }}></span>
                        <span> Supplied</span>
                      </div>
                    </>
                  ) : transaction?.transactionDetails.deliveryStatus === "returned" ? (
                    <div style={{ backgroundColor: "rgb(241, 241, 241)" }} className={`Tstatus  `}>
                      <span style={{ height: "6px", width: "6px", backgroundColor: "rgb(96, 96, 96)", borderRadius: "40px" }}></span>
                      <span style={{ color: "rgb(78, 78, 78)" }}> returned</span>
                    </div>
                  ) : (
                    <div style={{ backgroundColor: "rgba(254, 246, 245, 1)" }} className={`Tstatus TstatusLoanNotCleared `}>
                      <span style={{ height: "6px", width: "6px", backgroundColor: "rgba(244, 67, 54, 1)", borderRadius: "40px" }}></span>
                      <span style={{ color: "rgba(244, 67, 54, 1)" }}> Not supplied</span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Price Info */}
          <div className='transaction-card-price-info'>
            <div className='transaction-card-unit-price'>
              Unit: {currency + " "}
              {transaction?.products[0]?.soldUnitPrice.toLocaleString()}
            </div>
            <div className='transaction-card-total-price'>
              Total: {currency + " "}
              {transaction?.transactionDetails.totalAmount.toLocaleString()}{" "}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TransactionItem;
